/** @format */

import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { DeviceService, WINDOW } from '@shared/data-access/services';
import { chain } from '@core/chain';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronLeft
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'pdp-back-to-search-results',
	templateUrl: './back-to-search-results.component.html',
	styleUrl: './back-to-search-results.component.scss',
	imports: [HmfButtonComponent, HomefieldIconLibraryModule]
})
export class BackToSearchResultsComponent implements OnInit {
	public backButtonText = 'BACK TO SEARCH RESULTS';

	public dataEmText: string;

	public shouldShowBackButton = false;

	private isDesktop = false;

	private referrer = '';

	public chain = chain;

	constructor(
		private deviceService: DeviceService,
		private readonly homefieldIconsLibraryService: HomefieldIconsLibraryService,
		@Inject(DOCUMENT) private document: HTMLDocument,
		@Inject(PLATFORM_ID) private platformId,
		@Inject(WINDOW) private window: Window
	) {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconChevronLeft]);
	}

	ngOnInit() {
		// Check to see if execution context is browser or server
		if (isPlatformBrowser(this.platformId)) {
			this.isDesktop = this.deviceService.isDesktop();

			this.referrer = this.document.referrer;

			if (this.isDesktop && this.comingFromSlrpOrPlp() && this.window.history.length > 1) {
				this.shouldShowBackButton = true;
			}
		}
	}

	public backToSearchResults() {
		this.window.history.back();
	}

	private comingFromSlrpOrPlp(): boolean {
		let comingFromSlrpOrPlp = false;

		if (typeof this.referrer === 'string') {
			if (this.referrer.indexOf('/f/') > -1) {
				this.backButtonText = 'BACK TO RESULTS';

				this.dataEmText = 'PDP_BackToResults';

				comingFromSlrpOrPlp = true;
			} else if (this.referrer.indexOf('/SearchDisplay') > -1) {
				this.backButtonText = 'BACK TO SEARCH RESULTS';

				this.dataEmText = 'PDP_BackToSearchResults';

				comingFromSlrpOrPlp = true;
			}
		}
		return comingFromSlrpOrPlp;
	}
}
